import index from './cv'

export default index
